import React from 'react'
import PropTypes from 'prop-types'
import { Button, FormHelperText } from '@mui/material'

const IconLabelButton = ({ text, variant, color, startIcon, endIcon, onClick, helperText, ...restProps }) => (
  <>
    <Button variant={variant} color={color} startIcon={startIcon} endIcon={endIcon} onClick={onClick} {...restProps}>
      {text}
    </Button>
    {helperText && <FormHelperText error={color === 'error'}>{helperText}</FormHelperText>}
  </>
)

const iconLabelRequiredPropTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
}

IconLabelButton.propTypes = {
  ...iconLabelRequiredPropTypes,
  variant: PropTypes.string.isRequired,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  color: PropTypes.string,
  helperText: PropTypes.string,
}

IconLabelButton.defaultProps = {
  startIcon: null,
  endIcon: null,
  color: 'primary',
  helperText: '',
}

export const TransparentIconLabelButton = ({ text, variant, startIcon, endIcon, onClick, ...restProps }) => (
  <IconLabelButton
    text={text}
    variant={variant}
    startIcon={startIcon}
    endIcon={endIcon}
    onClick={onClick}
    {...restProps}
  />
)

TransparentIconLabelButton.propTypes = {
  ...iconLabelRequiredPropTypes,
  variant: PropTypes.string,
}

TransparentIconLabelButton.defaultProps = {
  variant: 'outlined',
}

export default IconLabelButton
